<template>
    <div class="compliance-summary">
        <table class="mb-3">
            <tr>
                <th>Effective</th>
                <td>
                    {{ compliance.effective }}
                </td>
            </tr>
            <tr>
                <th>Status</th>
                <td>
                    <compliance-badge :compliance="compliance"/>
                </td>
            </tr>
            <tr>
                <th>Notes</th>
                <td>{{ compliance.explanation }}</td>
            </tr>
        </table>

    </div>
</template>

<script>
export default {
    name: 'ComplianceSummary',
    props: {
        compliance: Object
    },
}
</script>
